import api from './api';

export interface Setting {
  id: number;
  key: string;
  value: string;
  description?: string;
  created_at?: string;
  updated_at?: string;
}

class SettingsService {
  async getAll(): Promise<Setting[]> {
    const response = await api.get('/settings');
    return response.data;
  }

  async get(key: string): Promise<{ key: string; value: any }> {
    const response = await api.get(`/settings/${key}`);
    return response.data;
  }

  async update(key: string, value: any, description?: string): Promise<Setting> {
    const response = await api.put(`/settings/${key}`, { value, description });
    return response.data;
  }

  async isCheckViewEnabled(): Promise<boolean> {
    try {
      const result = await this.get('check_view_enabled');
      return result.value === 'true' || result.value === true;
    } catch (error: any) {
      // Default to enabled if setting doesn't exist or if there's an error
      // Log error for debugging but don't throw
      if (error.response?.status !== 404) {
        console.warn('Error checking check_view_enabled setting:', error);
      }
      return true;
    }
  }

  async setCheckViewEnabled(enabled: boolean): Promise<Setting> {
    return this.update(
      'check_view_enabled',
      enabled.toString(),
      'Bật/tắt chức năng Check View YouTube cho người dùng'
    );
  }
}

export const settingsService = new SettingsService();
export default settingsService;

